import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';

const SportsActivitiesSingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <Panel
                    heading={"Sports Activity Details"}
                >

                    <MetaTable
                        data={data}
                        columnA={[
                            {
                                label: "Title",
                                key: "title",
                            },
                            {
                                label: "Brief Description",
                                key: "brief",
                            },
                            {
                                label: "Products",
                                key: "products",
                                format: "ModelLink",
                            },
                        ]}
                        columnB={[
                            {
                                label: "Thumbnail",
                                key: "thumbnail.fileId",
                                format: "image",
                                filters: {
                                    width: 60,
                                    height: 60
                                },
                                link: true
                            },
                            {
                                label: "Video",
                                key: "video.fileId",
                                format: "image",
                                filters: {
                                    width: 60,
                                    height: 60
                                },
                                link: true
                            },
                        ]}
                        columnC={[
                            {
                                label: "Status",
                                key: "status",
                                format: "titleCase"
                            },
                        ]}
                    />

                </Panel>

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default SportsActivitiesSingleView;
